import { render } from "./Cartridges.vue?vue&type=template&id=3afbf1a0"
import script from "./Cartridges.vue?vue&type=script&lang=js"
export * from "./Cartridges.vue?vue&type=script&lang=js"

import exportComponent from "/opt/sources/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__